import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  goodItemId: string;
  id: string;
}
export const useDeleteScreenshot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ goodItemId, id }: HookProps) => {
      if (goodItemId?.length) {
        const formData = new FormData();
        formData.append('goodItemId', goodItemId);

        const result = await apiClient.declarationsDocuments.deleteScreenshot.mutation({
          params: { id },
          body: formData,
        });

        if (result.status !== 200) throw result.body;

        return result.body.declaration;
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Screenshot was deleted successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the screenshot!`);
    },
  });
};
